type RedirectLocation = {
  pathname: string;
  search: string;
  hash: string;
};

const LOGIN_PATH = "/login";

export const getRedirectFromLocation = (location: RedirectLocation) => `${location.pathname}${location.search}${location.hash}`;

export const isValidAuthRedirect = (redirect: string | null | undefined): redirect is string => {
  if (!redirect) {
    return false;
  }

  if (!redirect.startsWith("/") || redirect.startsWith("//")) {
    return false;
  }

  return !redirect.toLowerCase().startsWith(LOGIN_PATH);
};

export const getSafeAuthRedirect = (redirect: string | null | undefined): string => {
  if (isValidAuthRedirect(redirect)) {
    return redirect;
  }

  return "/";
};

export const getLoginRedirectPath = (location: RedirectLocation) =>
  `${LOGIN_PATH}?redirect=${encodeURIComponent(getRedirectFromLocation(location))}`;
